import React from 'react'
import { Link } from 'react-router-dom'

import { Icon } from '~ui'

const BookmarksItemTag = React.memo(function BookmarksItemTag({ tag, spaceId }) {
    return (
        <Link
            key={tag}
            tabIndex='-1'
            to={'/my/' + spaceId + '/' + encodeURIComponent(tag.includes(' ') ? `"#${tag}"` : `#${tag}`)}>
            <Icon name='tag' size='micro' />
            {tag}
        </Link>
    )
})

const BookmarksItemTags = React.memo(function BookmarksItemTags({
    tags = [],
    className,
    spaceId
}) {
    if (!tags.length)
        return null

    return (
        <div className={className}>
            <span className={'ui-bm-tags'}>
                {tags.map(tag => (
                    <BookmarksItemTag
                        key={tag}
                        tag={tag}
                        spaceId={spaceId} />
                ))}
            </span>
        </div>
    )
})

export default BookmarksItemTags
